var exports = {
  "kL": "xa15a2ab7--f9ae68--container",
  "iE": "xa15a2ab7--f9ae68--wrapper",
  "DD": "xa15a2ab7--f9ae68--title",
};

module.exports = exports;
